module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/4.5-state-operation-flow.9c15101d.png";